export default __webpack_public_path__ + "static/media/BirdPage2.03f4ca12.txt";